"use strict";
// Generated from splitscript/antlr_files/Splitscript.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtomContext = exports.ExprSignedAtomContext = exports.ExprParenthesisContext = exports.ExprTimesDivContext = exports.ExprPowContext = exports.ExprComparisonContext = exports.ExprBooleanContext = exports.ExprPlusMinusContext = exports.ExprAtomContext = exports.ExprContext = exports.FormulaContext = exports.ProgramContext = void 0;
const antlr4_1 = require("antlr4");
class SplitscriptParser extends antlr4_1.Parser {
    static LPAREN = 1;
    static RPAREN = 2;
    static TIMES = 3;
    static POW = 4;
    static DIV = 5;
    static PLUS = 6;
    static MINUS = 7;
    static COMPARISON_OPERATIONS = 8;
    static BOOLEAN_OPERATIONS = 9;
    static INT = 10;
    static FLOAT = 11;
    static PERCENTAGE = 12;
    static STRING = 13;
    static BOOL = 14;
    static RANGE_REFERENCE = 15;
    static COLUMN = 16;
    static ARGS_SPLITTER = 17;
    static ID = 18;
    static COMMENTS = 19;
    static WS = 20;
    static EOF = antlr4_1.Token.EOF;
    static RULE_program = 0;
    static RULE_formula = 1;
    static RULE_expr = 2;
    static RULE_atom = 3;
    static literalNames = [null, "'('",
        "')'", "'*'",
        "'^'", "'/'",
        "'+'", "'-'"];
    static symbolicNames = [null, "LPAREN",
        "RPAREN", "TIMES",
        "POW", "DIV",
        "PLUS", "MINUS",
        "COMPARISON_OPERATIONS",
        "BOOLEAN_OPERATIONS",
        "INT", "FLOAT",
        "PERCENTAGE",
        "STRING", "BOOL",
        "RANGE_REFERENCE",
        "COLUMN", "ARGS_SPLITTER",
        "ID", "COMMENTS",
        "WS"];
    // tslint:disable:no-trailing-whitespace
    static ruleNames = [
        "program", "formula", "expr", "atom",
    ];
    get grammarFileName() { return "Splitscript.g4"; }
    get literalNames() { return SplitscriptParser.literalNames; }
    get symbolicNames() { return SplitscriptParser.symbolicNames; }
    get ruleNames() { return SplitscriptParser.ruleNames; }
    get serializedATN() { return SplitscriptParser._serializedATN; }
    createFailedPredicateException(predicate, message) {
        return new antlr4_1.FailedPredicateException(this, predicate, message);
    }
    constructor(input) {
        super(input);
        this._interp = new antlr4_1.ParserATNSimulator(this, SplitscriptParser._ATN, SplitscriptParser.DecisionsToDFA, new antlr4_1.PredictionContextCache());
    }
    // @RuleVersion(0)
    program() {
        let localctx = new ProgramContext(this, this._ctx, this.state);
        this.enterRule(localctx, 0, SplitscriptParser.RULE_program);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 8;
                this.expr(0);
                this.state = 9;
                this.match(SplitscriptParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof antlr4_1.RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    formula() {
        let localctx = new FormulaContext(this, this._ctx, this.state);
        this.enterRule(localctx, 2, SplitscriptParser.RULE_formula);
        let _la;
        try {
            this.state = 26;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 1, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 11;
                        this.match(SplitscriptParser.ID);
                        this.state = 12;
                        this.match(SplitscriptParser.LPAREN);
                        this.state = 13;
                        this.expr(0);
                        this.state = 18;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 17) {
                            {
                                {
                                    this.state = 14;
                                    this.match(SplitscriptParser.ARGS_SPLITTER);
                                    this.state = 15;
                                    this.expr(0);
                                }
                            }
                            this.state = 20;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        this.state = 21;
                        this.match(SplitscriptParser.RPAREN);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 23;
                        this.match(SplitscriptParser.ID);
                        this.state = 24;
                        this.match(SplitscriptParser.LPAREN);
                        this.state = 25;
                        this.match(SplitscriptParser.RPAREN);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof antlr4_1.RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expr(_p) {
        if (_p === undefined) {
            _p = 0;
        }
        let _parentctx = this._ctx;
        let _parentState = this.state;
        let localctx = new ExprContext(this, this._ctx, _parentState);
        let _prevctx = localctx;
        let _startState = 4;
        this.enterRecursionRule(localctx, 4, SplitscriptParser.RULE_expr, _p);
        let _la;
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 36;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 1:
                        {
                            localctx = new ExprParenthesisContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 29;
                            this.match(SplitscriptParser.LPAREN);
                            this.state = 30;
                            this.expr(0);
                            this.state = 31;
                            this.match(SplitscriptParser.RPAREN);
                        }
                        break;
                    case 6:
                    case 7:
                        {
                            localctx = new ExprSignedAtomContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 33;
                            _la = this._input.LA(1);
                            if (!(_la === 6 || _la === 7)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 34;
                            this.atom();
                        }
                        break;
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 18:
                        {
                            localctx = new ExprAtomContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 35;
                            this.atom();
                        }
                        break;
                    default:
                        throw new antlr4_1.NoViableAltException(this);
                }
                this._ctx.stop = this._input.LT(-1);
                this.state = 55;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 4, this._ctx);
                while (_alt !== 2 && _alt !== antlr4_1.ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        if (this._parseListeners != null) {
                            this.triggerExitRuleEvent();
                        }
                        _prevctx = localctx;
                        {
                            this.state = 53;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 3, this._ctx)) {
                                case 1:
                                    {
                                        localctx = new ExprPowContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, SplitscriptParser.RULE_expr);
                                        this.state = 38;
                                        if (!(this.precpred(this._ctx, 7))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 7)");
                                        }
                                        this.state = 39;
                                        this.match(SplitscriptParser.POW);
                                        this.state = 40;
                                        this.expr(8);
                                    }
                                    break;
                                case 2:
                                    {
                                        localctx = new ExprTimesDivContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, SplitscriptParser.RULE_expr);
                                        this.state = 41;
                                        if (!(this.precpred(this._ctx, 6))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 6)");
                                        }
                                        this.state = 42;
                                        _la = this._input.LA(1);
                                        if (!(_la === 3 || _la === 5)) {
                                            this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                        this.state = 43;
                                        this.expr(7);
                                    }
                                    break;
                                case 3:
                                    {
                                        localctx = new ExprPlusMinusContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, SplitscriptParser.RULE_expr);
                                        this.state = 44;
                                        if (!(this.precpred(this._ctx, 5))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 5)");
                                        }
                                        this.state = 45;
                                        _la = this._input.LA(1);
                                        if (!(_la === 6 || _la === 7)) {
                                            this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                        this.state = 46;
                                        this.expr(6);
                                    }
                                    break;
                                case 4:
                                    {
                                        localctx = new ExprComparisonContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, SplitscriptParser.RULE_expr);
                                        this.state = 47;
                                        if (!(this.precpred(this._ctx, 4))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 4)");
                                        }
                                        this.state = 48;
                                        this.match(SplitscriptParser.COMPARISON_OPERATIONS);
                                        this.state = 49;
                                        this.expr(5);
                                    }
                                    break;
                                case 5:
                                    {
                                        localctx = new ExprBooleanContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, SplitscriptParser.RULE_expr);
                                        this.state = 50;
                                        if (!(this.precpred(this._ctx, 3))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 3)");
                                        }
                                        this.state = 51;
                                        this.match(SplitscriptParser.BOOLEAN_OPERATIONS);
                                        this.state = 52;
                                        this.expr(4);
                                    }
                                    break;
                            }
                        }
                    }
                    this.state = 57;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 4, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof antlr4_1.RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.unrollRecursionContexts(_parentctx);
        }
        return localctx;
    }
    // @RuleVersion(0)
    atom() {
        let localctx = new AtomContext(this, this._ctx, this.state);
        this.enterRule(localctx, 6, SplitscriptParser.RULE_atom);
        try {
            this.state = 66;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 13:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 58;
                        this.match(SplitscriptParser.STRING);
                    }
                    break;
                case 12:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 59;
                        this.match(SplitscriptParser.PERCENTAGE);
                    }
                    break;
                case 10:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 60;
                        this.match(SplitscriptParser.INT);
                    }
                    break;
                case 11:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 61;
                        this.match(SplitscriptParser.FLOAT);
                    }
                    break;
                case 16:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 62;
                        this.match(SplitscriptParser.COLUMN);
                    }
                    break;
                case 15:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 63;
                        this.match(SplitscriptParser.RANGE_REFERENCE);
                    }
                    break;
                case 14:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 64;
                        this.match(SplitscriptParser.BOOL);
                    }
                    break;
                case 18:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 65;
                        this.formula();
                    }
                    break;
                default:
                    throw new antlr4_1.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr4_1.RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    sempred(localctx, ruleIndex, predIndex) {
        switch (ruleIndex) {
            case 2:
                return this.expr_sempred(localctx, predIndex);
        }
        return true;
    }
    expr_sempred(localctx, predIndex) {
        switch (predIndex) {
            case 0:
                return this.precpred(this._ctx, 7);
            case 1:
                return this.precpred(this._ctx, 6);
            case 2:
                return this.precpred(this._ctx, 5);
            case 3:
                return this.precpred(this._ctx, 4);
            case 4:
                return this.precpred(this._ctx, 3);
        }
        return true;
    }
    static _serializedATN = [4, 1, 20, 69, 2, 0, 7, 0, 2,
        1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 17, 8, 1, 10, 1, 12,
        1, 20, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 27, 8, 1, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2,
        3, 2, 37, 8, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2,
        5, 2, 54, 8, 2, 10, 2, 12, 2, 57, 9, 2, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 3, 3, 67, 8, 3,
        1, 3, 0, 1, 4, 4, 0, 2, 4, 6, 0, 2, 1, 0, 6, 7, 2, 0, 3, 3, 5, 5, 80, 0, 8, 1, 0, 0, 0, 2, 26, 1, 0, 0, 0,
        4, 36, 1, 0, 0, 0, 6, 66, 1, 0, 0, 0, 8, 9, 3, 4, 2, 0, 9, 10, 5, 0, 0, 1, 10, 1, 1, 0, 0, 0, 11, 12, 5,
        18, 0, 0, 12, 13, 5, 1, 0, 0, 13, 18, 3, 4, 2, 0, 14, 15, 5, 17, 0, 0, 15, 17, 3, 4, 2, 0, 16, 14, 1,
        0, 0, 0, 17, 20, 1, 0, 0, 0, 18, 16, 1, 0, 0, 0, 18, 19, 1, 0, 0, 0, 19, 21, 1, 0, 0, 0, 20, 18, 1, 0,
        0, 0, 21, 22, 5, 2, 0, 0, 22, 27, 1, 0, 0, 0, 23, 24, 5, 18, 0, 0, 24, 25, 5, 1, 0, 0, 25, 27, 5, 2,
        0, 0, 26, 11, 1, 0, 0, 0, 26, 23, 1, 0, 0, 0, 27, 3, 1, 0, 0, 0, 28, 29, 6, 2, -1, 0, 29, 30, 5, 1, 0,
        0, 30, 31, 3, 4, 2, 0, 31, 32, 5, 2, 0, 0, 32, 37, 1, 0, 0, 0, 33, 34, 7, 0, 0, 0, 34, 37, 3, 6, 3, 0,
        35, 37, 3, 6, 3, 0, 36, 28, 1, 0, 0, 0, 36, 33, 1, 0, 0, 0, 36, 35, 1, 0, 0, 0, 37, 55, 1, 0, 0, 0, 38,
        39, 10, 7, 0, 0, 39, 40, 5, 4, 0, 0, 40, 54, 3, 4, 2, 8, 41, 42, 10, 6, 0, 0, 42, 43, 7, 1, 0, 0, 43,
        54, 3, 4, 2, 7, 44, 45, 10, 5, 0, 0, 45, 46, 7, 0, 0, 0, 46, 54, 3, 4, 2, 6, 47, 48, 10, 4, 0, 0, 48,
        49, 5, 8, 0, 0, 49, 54, 3, 4, 2, 5, 50, 51, 10, 3, 0, 0, 51, 52, 5, 9, 0, 0, 52, 54, 3, 4, 2, 4, 53,
        38, 1, 0, 0, 0, 53, 41, 1, 0, 0, 0, 53, 44, 1, 0, 0, 0, 53, 47, 1, 0, 0, 0, 53, 50, 1, 0, 0, 0, 54, 57,
        1, 0, 0, 0, 55, 53, 1, 0, 0, 0, 55, 56, 1, 0, 0, 0, 56, 5, 1, 0, 0, 0, 57, 55, 1, 0, 0, 0, 58, 67, 5,
        13, 0, 0, 59, 67, 5, 12, 0, 0, 60, 67, 5, 10, 0, 0, 61, 67, 5, 11, 0, 0, 62, 67, 5, 16, 0, 0, 63, 67,
        5, 15, 0, 0, 64, 67, 5, 14, 0, 0, 65, 67, 3, 2, 1, 0, 66, 58, 1, 0, 0, 0, 66, 59, 1, 0, 0, 0, 66, 60,
        1, 0, 0, 0, 66, 61, 1, 0, 0, 0, 66, 62, 1, 0, 0, 0, 66, 63, 1, 0, 0, 0, 66, 64, 1, 0, 0, 0, 66, 65, 1,
        0, 0, 0, 67, 7, 1, 0, 0, 0, 6, 18, 26, 36, 53, 55, 66];
    static __ATN;
    static get _ATN() {
        if (!SplitscriptParser.__ATN) {
            SplitscriptParser.__ATN = new antlr4_1.ATNDeserializer().deserialize(SplitscriptParser._serializedATN);
        }
        return SplitscriptParser.__ATN;
    }
    static DecisionsToDFA = SplitscriptParser._ATN.decisionToState.map((ds, index) => new antlr4_1.DFA(ds, index));
}
exports.default = SplitscriptParser;
class ProgramContext extends antlr4_1.ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    EOF() {
        return this.getToken(SplitscriptParser.EOF, 0);
    }
    get ruleIndex() {
        return SplitscriptParser.RULE_program;
    }
    enterRule(listener) {
        if (listener.enterProgram) {
            listener.enterProgram(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProgram) {
            listener.exitProgram(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProgram) {
            return visitor.visitProgram(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ProgramContext = ProgramContext;
class FormulaContext extends antlr4_1.ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ID() {
        return this.getToken(SplitscriptParser.ID, 0);
    }
    LPAREN() {
        return this.getToken(SplitscriptParser.LPAREN, 0);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    RPAREN() {
        return this.getToken(SplitscriptParser.RPAREN, 0);
    }
    ARGS_SPLITTER_list() {
        return this.getTokens(SplitscriptParser.ARGS_SPLITTER);
    }
    ARGS_SPLITTER(i) {
        return this.getToken(SplitscriptParser.ARGS_SPLITTER, i);
    }
    get ruleIndex() {
        return SplitscriptParser.RULE_formula;
    }
    enterRule(listener) {
        if (listener.enterFormula) {
            listener.enterFormula(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFormula) {
            listener.exitFormula(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFormula) {
            return visitor.visitFormula(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.FormulaContext = FormulaContext;
class ExprContext extends antlr4_1.ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return SplitscriptParser.RULE_expr;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
exports.ExprContext = ExprContext;
class ExprAtomContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    atom() {
        return this.getTypedRuleContext(AtomContext, 0);
    }
    enterRule(listener) {
        if (listener.enterExprAtom) {
            listener.enterExprAtom(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprAtom) {
            listener.exitExprAtom(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprAtom) {
            return visitor.visitExprAtom(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprAtomContext = ExprAtomContext;
class ExprPlusMinusContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    PLUS() {
        return this.getToken(SplitscriptParser.PLUS, 0);
    }
    MINUS() {
        return this.getToken(SplitscriptParser.MINUS, 0);
    }
    enterRule(listener) {
        if (listener.enterExprPlusMinus) {
            listener.enterExprPlusMinus(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprPlusMinus) {
            listener.exitExprPlusMinus(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprPlusMinus) {
            return visitor.visitExprPlusMinus(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprPlusMinusContext = ExprPlusMinusContext;
class ExprBooleanContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    BOOLEAN_OPERATIONS() {
        return this.getToken(SplitscriptParser.BOOLEAN_OPERATIONS, 0);
    }
    enterRule(listener) {
        if (listener.enterExprBoolean) {
            listener.enterExprBoolean(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprBoolean) {
            listener.exitExprBoolean(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprBoolean) {
            return visitor.visitExprBoolean(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprBooleanContext = ExprBooleanContext;
class ExprComparisonContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    COMPARISON_OPERATIONS() {
        return this.getToken(SplitscriptParser.COMPARISON_OPERATIONS, 0);
    }
    enterRule(listener) {
        if (listener.enterExprComparison) {
            listener.enterExprComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprComparison) {
            listener.exitExprComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprComparison) {
            return visitor.visitExprComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprComparisonContext = ExprComparisonContext;
class ExprPowContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    POW() {
        return this.getToken(SplitscriptParser.POW, 0);
    }
    enterRule(listener) {
        if (listener.enterExprPow) {
            listener.enterExprPow(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprPow) {
            listener.exitExprPow(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprPow) {
            return visitor.visitExprPow(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprPowContext = ExprPowContext;
class ExprTimesDivContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    TIMES() {
        return this.getToken(SplitscriptParser.TIMES, 0);
    }
    DIV() {
        return this.getToken(SplitscriptParser.DIV, 0);
    }
    enterRule(listener) {
        if (listener.enterExprTimesDiv) {
            listener.enterExprTimesDiv(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprTimesDiv) {
            listener.exitExprTimesDiv(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprTimesDiv) {
            return visitor.visitExprTimesDiv(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprTimesDivContext = ExprTimesDivContext;
class ExprParenthesisContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LPAREN() {
        return this.getToken(SplitscriptParser.LPAREN, 0);
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    RPAREN() {
        return this.getToken(SplitscriptParser.RPAREN, 0);
    }
    enterRule(listener) {
        if (listener.enterExprParenthesis) {
            listener.enterExprParenthesis(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprParenthesis) {
            listener.exitExprParenthesis(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprParenthesis) {
            return visitor.visitExprParenthesis(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprParenthesisContext = ExprParenthesisContext;
class ExprSignedAtomContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    atom() {
        return this.getTypedRuleContext(AtomContext, 0);
    }
    PLUS() {
        return this.getToken(SplitscriptParser.PLUS, 0);
    }
    MINUS() {
        return this.getToken(SplitscriptParser.MINUS, 0);
    }
    enterRule(listener) {
        if (listener.enterExprSignedAtom) {
            listener.enterExprSignedAtom(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExprSignedAtom) {
            listener.exitExprSignedAtom(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExprSignedAtom) {
            return visitor.visitExprSignedAtom(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ExprSignedAtomContext = ExprSignedAtomContext;
class AtomContext extends antlr4_1.ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STRING() {
        return this.getToken(SplitscriptParser.STRING, 0);
    }
    PERCENTAGE() {
        return this.getToken(SplitscriptParser.PERCENTAGE, 0);
    }
    INT() {
        return this.getToken(SplitscriptParser.INT, 0);
    }
    FLOAT() {
        return this.getToken(SplitscriptParser.FLOAT, 0);
    }
    COLUMN() {
        return this.getToken(SplitscriptParser.COLUMN, 0);
    }
    RANGE_REFERENCE() {
        return this.getToken(SplitscriptParser.RANGE_REFERENCE, 0);
    }
    BOOL() {
        return this.getToken(SplitscriptParser.BOOL, 0);
    }
    formula() {
        return this.getTypedRuleContext(FormulaContext, 0);
    }
    get ruleIndex() {
        return SplitscriptParser.RULE_atom;
    }
    enterRule(listener) {
        if (listener.enterAtom) {
            listener.enterAtom(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAtom) {
            listener.exitAtom(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAtom) {
            return visitor.visitAtom(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.AtomContext = AtomContext;
